var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer has-text-centered has-background-transparent"},[_c('span',{staticClass:"has-text-grey-light has-text-weight-semibold"},[_vm._v("RELEASER")]),_c('p',{staticClass:"has-text-grey-light is-size-7"},[_vm._v("© "+_vm._s(_vm.FullYear))])])
}
var staticRenderFns = []

export { render, staticRenderFns }